var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    stroke: "#46A358",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1653 13.4299L22.168 13.4306C22.168 13.4306 22.1676 13.4305 22.1667 13.4303C22.1663 13.4302 22.1658 13.4301 22.1653 13.4299ZM11.3244 13.3569C13.9176 13.1957 18.7483 13.1957 21.3415 13.3569L21.3422 13.3644C21.4047 13.9972 21.4299 14.8414 21.4299 16.0192C21.4299 17.1824 21.4053 18.0269 21.3441 18.665C18.6962 18.7703 13.9713 18.7703 11.3228 18.665C11.261 18.0332 11.236 17.1914 11.236 16.0192C11.236 14.8414 11.2612 13.9972 11.3237 13.3644L11.3244 13.3569ZM22.2422 18.6111C22.2422 18.6111 22.2405 18.6115 22.237 18.6122L22.2422 18.6111ZM10.4979 18.6077L10.5006 18.6084C10.4988 18.6079 10.4979 18.6077 10.4979 18.6077ZM7 16.0192C7 20.8412 7.38887 22.63 10.4221 22.8633C13.222 23.0189 19.4439 23.0189 22.2438 22.8633C25.277 22.7078 25.6659 20.8412 25.6659 16.0192C25.6659 11.1971 25.277 9.40832 22.2438 9.17499C19.4439 8.94167 13.222 8.94167 10.4221 9.17499C7.38887 9.40832 7 11.1971 7 16.0192ZM10.4979 13.4306C10.4979 13.4306 10.4988 13.4304 10.5007 13.4299L10.4979 13.4306ZM16.7823 17.7389C15.5039 18.3781 13.9997 17.4484 13.9997 16.0192C13.9997 14.5899 15.5039 13.6602 16.7823 14.2994C18.1994 15.008 18.1994 17.0303 16.7823 17.7389Z",
    fill: "#46A358",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.1c288d3ffbe5e8abbfeba96a9ddf0f2d.svg";
export { ForwardRef as ReactComponent };